/** @flow */

import React from "react";
import { formatDate } from "@transformers/date";
import { answerTypesEnum } from "@modules/reporting/constants/reports";

export const formatQuestionAnswerResponse = (
  answer: ?{ type: string, value: string },
  t: string => string,
  isPrinting?: boolean,
) => {
  let resp = "";
  if (!answer) resp = "";
  else if (answer.type === answerTypesEnum.CONFIRMATION) return answer.value ? t("YES") : t("NO");
  else if (answer.type === answerTypesEnum.MULTI_SELECT && Array.isArray(answer.value))
    return answer.value.join("; ");
  else if (
    answer.type === answerTypesEnum.DATE_PICK &&
    typeof new Date(answer.value).getTime() === "number"
  ) {
    return formatDate(answer.value);
  } else {
    // FREE_TEXT || SINGLE_SELECT
    resp = answer.value;
  }

  if (isPrinting) {
    return (
      <pre className="no-resize background-color-transparent borders-solid-color-white p-1">
        {resp}
      </pre>
    );
  }

  return (
    <textarea
      disabled
      rows="3"
      maxLength="600"
      className="no-resize background-color-transparent borders-solid-color-white fs-14 line-height-20 p-1"
      defaultValue={resp}
    />
  );
};
